export default {
  name: "Graziani",
  apiUrl: "https://api.graziani.fast-it.app/",
};
